export function genSaveProDis (d) {
  let co = []
  let acode = d.state_code.acc_code
  let pcode = d.state_code.p_code
  let dcode = d.state_code.d_code
  let ipf = null
  /** calcualte for is pro form */
  if (dcode === '0000') {
    ipf = "b'1'" // bit value ZERO is district form data
  } else {
    ipf = "b'0'"
  }
  /* emis_pro_director block
    id, academic_code, pro_code, dis_code, name_kh, name_en, official_id, date_of_birth, gender,
    education_code, total_service, director_service, telephone, email, is_pro_form
  */
  let t = d.emis_dir
  let date = null

  if (t.dob === '') {
    date = null
  } else {
    date = "'" + formatDate(t.dob) + "'" // if dob not null then value must be string
  }
  let strDt = '(' + t.id + ',' + acode + ",'" + pcode + "','" + dcode + "','" + t.name_kh +
    "','" + t.name_en + "','" + t.oid + "'," + date + ',' + t.gen + ',' +
    t.edu_code + ',' + t.tot_ser + ',' + t.dir_ser + ",'" + t.tel_pho +
    "','" + t.email + "'," + ipf + ')'
  co.push(strDt)

  /* emis_pro_position_management block
    id, academic_code, pro_code, dis_code, position_code, number_total,
    number_female, attend_total, attend_female, is_pro_form
  */
  strDt = ''
  t = d.emis_pos
  for (let i = 0; i < t.length; i++) {
    strDt += '(' + t[i].id + ',' + acode + ",'" + pcode + "','" + dcode + "'," + t[i].pc + ',' +
    t[i].dt + ',' + ipf + '),'
  }
  strDt = strDt.slice(0, -1)
  co.push(strDt)

  /* emis_pro_staff_age
  id, academic_code, pro_code, dis_code, age_item_id, total, female, is_pro_form
  */
  strDt = ''
  t = d.emis_age
  for (let i = 0; i < t.length; i++) {
    strDt += '(' + t[i].id + ',' + acode + ",'" + pcode + "','" + dcode + "'," + t[i].ai + ',' +
    t[i].dt + ',' + ipf + '),'
  }
  strDt = strDt.slice(0, -1)
  co.push(strDt)

  /* emis_pro_service_education block
  id, academic_code, pro_code, dis_code, service_item_id, total, female, is_pro_form
  */
  strDt = ''
  t = d.emis_ser
  for (let i = 0; i < t.length; i++) {
    strDt += '(' + t[i].id + ',' + acode + ",'" + pcode + "','" + dcode + "'," + t[i].aii + ',' +
    t[i].dt + ',' + ipf + '),'
  }
  strDt = strDt.slice(0, -1)
  co.push(strDt)

  /* emis_pro_service_other block
  id, academic_code, pro_code, dis_code, literacy_teachers, undergo_training, special_contract, is_pro_form
  */
  strDt = ''
  t = d.emis_oth[0]
  strDt = '(' + t.id + ',' + acode + ",'" + pcode + "','" + dcode + "'," + t.dt + ',' + ipf + ')'
  co.push(strDt)

  /* emis_pro_salaryscale block
  id, academic_code, pro_code, dis_code, scale_code, total, female, is_pro_form
  */
  strDt = ''
  t = d.emis_sal
  for (let i = 0; i < t.length; i++) {
    strDt += '(' + t[i].id + ',' + acode + ",'" + pcode + "','" + dcode + "'," + t[i].sc + ',' +
    t[i].dt + ',' + ipf + '),'
  }
  strDt = strDt.slice(0, -1)
  co.push(strDt)

  /*  emis_pro_education_levelblock
  id, academic_code, pro_code, dis_code, education_code, total, female, is_pro_form
  */
  strDt = ''
  t = d.emis_edu
  for (let i = 0; i < t.length; i++) {
    strDt += '(' + t[i].id + ',' + acode + ",'" + pcode + "','" + dcode + "'," + t[i].ec + ',' +
    t[i].dt + ',' + ipf + '),'
  }
  strDt = strDt.slice(0, -1)
  co.push(strDt)

  /* emis_pro_education_hiv block
  id, academic_code, pro_code, dis_code, staff_total, staff_female, lecturer_total, lecturer_female, is_pro_form
  */
  strDt = ''
  t = d.emis_hiv[0]
  strDt = '(' + t.id + ',' + acode + ",'" + pcode + "','" + dcode + "'," + t.dt + ',' + ipf + ')'
  co.push(strDt)

  /* emis_pro_staff_office block
  id, academic_code, pro_code, dis_code, ref_num, office_name, total, female, is_pro_form
  */
  strDt = ''
  t = d.emis_off
  for (let i = 0; i < t.length; i++) {
    strDt += '(' + t[i].id + ',' + acode + ",'" + pcode + "','" + dcode + "'," +
    t[i].dt[0] + ",'" + t[i].dt[1] + "'," + t[i].dt[2] + ',' + t[i].dt[3] + ',' + ipf + '),'
  }
  strDt = strDt.slice(0, -1)
  co.push(strDt)

  return co
}

const formatDate = (date) => {
  return date.split('-').reverse().join('-')
}
